/**
 * Simplified resize.js by Anton Berezinets
 * Requires JQUERY
 * Last update: May 2017
 * TODO: Rewrite without JQUERY
 */

var vps = [
    ["vp-1600", 1600, 1],
    ["vp-640", 640, 1]
];


$(document).ready(function () {
    pageResize = {};

    var currentBreakpoint = '';

    pageResize.work = function (vps) {
        currentBreakpoint = '';
        var wWidth = $(window).width();
        var addClasses = '';
        var removeClasses = '';

        for (var i = 0; i < vps.length; i++) {
            if (wWidth < vps[i][1]) {
                addClasses += ' ' + vps[i][0];

                currentBreakpoint = i;
            } else {
                removeClasses += ' ' + vps[i][0];
            }

        }

        if (currentBreakpoint !== '') {
            if (vps[currentBreakpoint][2] === 1) {
                $('html').css('font-size', 16 * (wWidth / vps[currentBreakpoint][1]));
            } else {
                $('html').css('font-size', '16px');
            }
        } else {
            $('html').css('font-size', '16px');
        }

        $('body').removeClass(removeClasses);
        $('body').addClass(addClasses);
    };

    pageResize.init = function (vps) {

        $(window).resize(function () {
            pageResize.work(vps);
            $(window).trigger("pageresize");
        });
        pageResize.work(vps);

    };

    pageResize.init(vps);

});




//////////////////
// WEBPACK FOOTER
// ./js/_resize.js
// module id = 8
// module chunks = 0